module.exports = __webpack_public_path__ + "img/appIcon.9e62115e.png";